import { z } from 'zod';

/** Texto obligatorio, recortado. */
export const requiredText = (max: number) =>
  z
    .string({ error: 'Campo obligatorio' })
    .trim()
    .min(1, 'Campo obligatorio')
    .max(max, `Máximo ${max} caracteres`);

/** Texto opcional: cadenas vacías se guardan como null. */
export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max, `Máximo ${max} caracteres`)
    .nullish()
    .transform((value) => (value ? value : null));

export const optionalEmail = optionalText(200).refine(
  (value) => value === null || z.email().safeParse(value).success,
  'Email no válido',
);

/** Fecha sin hora (AAAA-MM-DD). */
export const isoDate = z.iso.date({ error: 'Fecha no válida (AAAA-MM-DD)' });

/** Fecha y hora ISO 8601 con zona; se convierte a Date. */
export const isoDateTime = z.iso
  .datetime({ offset: true, error: 'Fecha y hora no válidas' })
  .transform((value) => new Date(value));

export const idSchema = z.coerce.number().int().positive();

export const idParamsSchema = z.object({ id: idSchema });

/** Booleano en query string ("true"/"false"). */
export const queryBoolean = z
  .enum(['true', 'false'])
  .optional()
  .transform((value) => (value === undefined ? undefined : value === 'true'));

export const MAX_PAGE_SIZE = 200;

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(50),
});

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

/** Importe en céntimos (entero no negativo). */
export const centsSchema = z
  .number()
  .int('Importe en céntimos')
  .min(0, 'No puede ser negativo')
  .max(100_000_000);
